var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.79733 19.2214C5.09855 20.5227 7.19285 20.5227 11.3814 20.5227C15.57 20.5227 17.6644 20.5227 18.9655 19.2214C20.2668 17.9202 20.2668 15.8259 20.2668 11.6373C20.2668 7.44871 20.2668 5.35441 18.9655 4.05319C17.6644 2.75195 15.57 2.75195 11.3814 2.75195C7.19285 2.75195 5.09855 2.75195 3.79733 4.05319C2.49609 5.35441 2.49609 7.44871 2.49609 11.6373C2.49609 15.8259 2.49609 17.9202 3.79733 19.2214Z",
    fill: "#00AA5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82656 14.5234C7.45852 14.5234 7.16016 14.8218 7.16016 15.1898C7.16016 15.5579 7.45852 15.8562 7.82656 15.8562H14.9348C15.3029 15.8562 15.6012 15.5579 15.6012 15.1898C15.6012 14.8218 15.3029 14.5234 14.9348 14.5234H7.82656Z",
    fill: "#00AA5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8249 10.082H6.93957H5.1625C4.79445 10.082 4.49609 10.3804 4.49609 10.7484C4.49609 11.1165 4.79445 11.4148 5.1625 11.4148H17.602C17.97 11.4148 18.2684 11.1165 18.2684 10.7484C18.2684 10.3804 17.97 10.082 17.602 10.082H15.8249Z",
    fill: "#00AA5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M12.2687 6.30469H10.4916C8.8162 6.30469 7.97848 6.30469 7.458 6.82518C6.9375 7.34567 6.9375 8.18339 6.9375 9.85883V10.081H15.8229V9.85883C15.8229 8.18339 15.8229 7.34567 15.3023 6.82518C14.7818 6.30469 13.9441 6.30469 12.2687 6.30469Z",
    fill: "#00AA5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardholder);
export default __webpack_public_path__ + "static/media/cardholder.7d58aa7637d6584968c65cb5c5c0bb63.svg";
export { ForwardRef as ReactComponent };